import date from 'date-and-time';

export const formatDate = (d: Date, char: string): string =>
  date.format(d, `MM${char}DD${char}YYYY`);

const HOURS_IN_DAY = 24;
const MINUTES_IN_HOUR = 60;
const SECONDS_IN_MINUTE = 60;
const MILLISECONDS_IN_SECOND = 1000;

export const addDaysToDate = (startDate: Date, days: number): Date =>
  new Date(
    new Date(startDate).getTime() +
      days *
        HOURS_IN_DAY *
        MINUTES_IN_HOUR *
        SECONDS_IN_MINUTE *
        MILLISECONDS_IN_SECOND
  );
